<template>
  <div style="padding: 15px">
    <div v-if="globalData.setting.required_title" class="text-center" style="font-weight: 600; font-size: 14px">
      {{globalData.setting.required_title}}
    </div>
    <div class="cool-input" v-if="globalData.setting.required_field.name.is_show">
      <label for="input" class="text">Họ và tên <span v-if="globalData.setting.required_field.name.is_required"
                                                       class="required">*</span></label>
      <input type="text" id="name" name="name" v-model="name" class="input" autocomplete="off"
             :class="{ 'input-error': globalData.setting.required_field.name.is_required && !name && hasSubmitted }">
    </div>

    <div class="cool-input" v-if="globalData.setting.required_field.phone.is_show">
      <label for="input" class="text">Số điện thoại <span v-if="globalData.setting.required_field.phone.is_required"
                                                       class="required">*</span></label>
      <input type="text" id="phone" name="phone" v-model="phone" class="input" autocomplete="off"
             :class="{ 'input-error': (globalData.setting.required_field.phone.is_required && !phone && hasSubmitted) || check_phone }">
    </div>

    <div class="cool-input" v-if="globalData.setting.required_field.mail.is_show">
      <label for="input" class="text">Email <span v-if="globalData.setting.required_field.mail.is_required"
                                                          class="required">*</span></label>
      <input type="text" id="mail" name="mail" v-model="mail" class="input" autocomplete="off"
             :class="{ 'input-error': (globalData.setting.required_field.mail.is_required && !mail && hasSubmitted) || check_mail }">
    </div>

    <div class="cool-input" v-if="globalData.setting.required_field.interest_content.is_show">
      <label for="input" class="text">Ghi chú <span v-if="globalData.setting.required_field.interest_content.is_required"
                                                  class="required">*</span></label>
              <textarea
                  name="textarea"
                  id="textarea"
                  rows="3"
                  cols="50"
                  v-model="interest_content"
                  class="textarea"
                  autocomplete="off"
                  :class="{ 'input-error': globalData.setting.required_field.interest_content.is_required && !interest_content && hasSubmitted }"
              ></textarea>
    </div>

    <button class="form-submit-btn btn-primary" type="submit" @click="saveInfo()">Bắt đầu</button>
  </div>
</template>

<script>

export default {
  name: 'ChatForm',
  data() {
    return {
      hasSubmitted: false,
      name: '',
      phone: '',
      mail: '',
      interest_content: '',
      check_phone: false,
      check_mail: false,
    }
  },
  methods: {
    saveInfo() {
      this.hasSubmitted = true;
      this.name = this.name.trim()
      this.phone = this.phone.trim()
      this.mail = this.mail.trim()
      this.interest_content = this.interest_content.trim()
      if (this.isValidForm()) {
        this.globalData.required_field.name = this.name
        this.globalData.required_field.phone = this.phone
        this.globalData.required_field.mail = this.mail
        this.globalData.required_field.interest_content = this.interest_content

        this.globalData.setting.is_required_field = false
        localStorage.setItem('is_required_field', JSON.stringify(false));
        if(this.interest_content.trim().length> 0){
          this.$root.$emit('openChat', {content: this.interest_content})
        }
      }
    },
    isValidForm() {
      if (this.globalData.setting.required_field.name.is_show && this.globalData.setting.required_field.name.is_required && !this.name) {
        return false;
      }
      if (this.globalData.setting.required_field.phone.is_show && this.globalData.setting.required_field.phone.is_required && !this.phone) {
        return false;
      }
      if(this.globalData.setting.required_field.phone.is_show && !this.phoneValidate()){
        console.log(this.phoneValidate())
        this.check_phone = true;
        return false;
      }
      this.check_phone = false;
      if (this.globalData.setting.required_field.mail.is_show && this.globalData.setting.required_field.mail.is_required && !this.mail) {
        return false;
      }
      if(this.globalData.setting.required_field.mail.is_show && !this.emailValidate()){
        this.check_mail = true;
        return false;
      }
      this.check_mail = false;
      if ( this.globalData.setting.required_field.interest_content.is_show && this.globalData.setting.required_field.interest_content.is_required && !this.interest_content) {
        return false;
      }
      return true;
    },

    phoneValidate() {
      if(this.phone?.length ===0){
        return true
      }
      const regex = /^(0|\+84)(\d{9,10})$/;
      return regex.test(this.phone)  ? true : false;
    },

    emailValidate() {
      if(this.mail?.length ===0){
        return true
      }
      const regex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
      return regex.test(this.mail) ? true : false;
    },

  },
};
</script>

<style scoped>

.input-error {
  border: 2px solid #fd7575 !important;
}

.form-container {
  background-color: white;
  width: 100%;
  border: 2px solid transparent;
  padding: 12px 24px;
  font-size: 16px;
  font-family: inherit;
  flex-direction: column;
  gap: 20px;
  box-sizing: border-box;
  border-radius: 16px;
}

.form-container button:active {
  scale: 0.95;
}

.form-container .form {
  display: flex;
  flex-direction: column;
}

.form-container .form-group {
  display: flex;
  flex-direction: column;
}

.form-container .form-group label {
  display: block;
  margin-bottom: 5px;
  color: #717171;
  font-weight: 600;
  font-size: 14px;
}

.form-container .form-group input {
  width: 100%;
  padding: 8px 16px;
  border-radius: 8px;
  font-family: inherit;
  background-color: transparent;
  border: 1px solid #414141;
}

.form-container .form-group textarea {
  width: 100%;
  padding: 12px 16px;
  border-radius: 8px;
  resize: none;
  height: 96px;
  border: 1px solid #414141;
  background-color: transparent;
  font-family: inherit;
}

.form-container .form-group input::placeholder {
  opacity: 0.5;
}

.form-container .form-group input:focus {
  outline: none;
}

.form-container .form-group textarea:focus {
  outline: none;
}

.form-submit-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  font-family: inherit;
  font-weight: 600;
  width: 40%;
  padding: 8px 16px;
  font-size: inherit;
  margin-top: 8px;
  cursor: pointer;
  border-radius: 6px;
  position: absolute;
  bottom: 20px;
  left: 33%;
}

.required{
  color: red !important;
}

.cool-input {
  display: flex;
  flex-direction: column;
  position: static;
  width: 330px;
}

.cool-input label.text {
  font-size: 14px;
  font-weight: 400;
  position: relative;
  top: 0.5rem;
  margin: 0 0 0 7px;
  padding: 0 3px;
  background: white;
  width: fit-content;
}

.cool-input input[type=text].input {
  padding: 10px 10px;
  font-size: 16px;
  border: 1px solid #7e7e7e;
  border-radius: 8px;
  background: white;
}

.cool-input input[type=text].input:focus {
  outline: none;
}

.textarea{
  border-radius: 8px;
  padding: 10px;
  height: 90px;
  resize: none;
}
.textarea:focus{
  outline: none;
}

</style>
